import React, {Component} from 'react'
import * as authService from '../common/services/authService';

export default class AuthComponent extends Component {

    componentWillMount() {
        this.redirectToLoginIfRequired();
    }

    componentWillReceiveProps() {
        this.redirectToLoginIfRequired();
    }

    componentWillUpdate() {
        this.redirectToLoginIfRequired();
    }

    redirectToLoginIfRequired() {
        if (authService.isLoggedOut()) {
            this.context.router.push('/login');
        }
    }

    render() {
        if (authService.isLoggedOut()) {
            return <p>Go to /login page</p>
        } else {
            return this.props.wrapped;
        }
    }

}

AuthComponent.contextTypes = {
  router: React.PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/auth/AuthComponent.js